import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { registrarServiceWorker } from './push/push';
import { initPrefs } from './helpers/prefs';

// Aplica o tema salvo (claro/escuro) antes da UI aparecer.
initPrefs();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

// Registra o Service Worker de push (padrao 10-notificacoes.md). Silencioso se
// nao suportado. A inscricao em si so acontece quando o usuario ativa os avisos.
registrarServiceWorker();
